import { render } from "./OrderCargoSummary.vue?vue&type=template&id=6ebbfae1"
import script from "./OrderCargoSummary.vue?vue&type=script&lang=js"
export * from "./OrderCargoSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__